export const heroManhua = {
  title: '独步天下',
  subtitle: '虚空韩漫网年度最热连载',
  description: '一介平民重生归来，手握逆天功法，脚踏九州四海。昔日仇敌尽在掌握，且看他如何独步天下，傲视群雄！',
  author: '金泰亨',
  genre: '奇幻 / 武侠 / 重生',
  rating: '9.6',
  views: '1,258万',
  latestChapter: '第287话',
  imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20epic%20martial%20arts%20fantasy%20scene%2C%20dramatic%20composition%20with%20ancient%20Asian%20warrior%20silhouette%20against%20golden%20sunset%20sky%2C%20ink%20wash%20painting%20influence%20with%20modern%20digital%20art%20style%2C%20warm%20amber%20and%20crimson%20tones%2C%20atmospheric%20with%20floating%20particles%2C%20cinematic%20lighting&width=1600&height=800&seq=hero-manhua-01&orientation=landscape',
};

export const hotRecommendations = [
  {
    id: '1',
    title: '剑尊归来',
    author: '李贤宇',
    genre: '武侠 / 重生',
    rating: '9.8',
    views: '2,156万',
    latestChapter: '第312话',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20martial%20arts%20male%20character%20with%20sword%2C%20dramatic%20vibrant%20colors%2C%20clean%20simple%20background%2C%20digital%20illustration%20with%20soft%20lighting%2C%20webtoon%20aesthetic%2C%20professional%20comic%20cover%20quality&width=400&height=533&seq=hot-rec-01&orientation=portrait',
  },
  {
    id: '2',
    title: '我独自升级',
    author: '崔秀敏',
    genre: '奇幻 / 战斗',
    rating: '9.7',
    views: '5,820万',
    latestChapter: '第179话',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20dark%20fantasy%20male%20character%20with%20glowing%20eyes%2C%20intense%20expression%2C%20dramatic%20lighting%2C%20vibrant%20purple%20and%20black%20tones%2C%20professional%20webtoon%20cover%20style&width=400&height=533&seq=hot-rec-02&orientation=portrait',
  },
  {
    id: '3',
    title: '女神降临',
    author: '朴世美',
    genre: '恋爱 / 校园',
    rating: '9.5',
    views: '3,420万',
    latestChapter: '第256话',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20beautiful%20female%20character%20with%20soft%20smile%2C%20romantic%20atmosphere%2C%20pastel%20pink%20and%20peach%20tones%2C%20school%20uniform%2C%20shojo%20style%20digital%20illustration&width=400&height=533&seq=hot-rec-03&orientation=portrait',
  },
  {
    id: '4',
    title: '全知读者视角',
    author: '崔元英',
    genre: '奇幻 / 生存',
    rating: '9.6',
    views: '4,180万',
    latestChapter: '第203话',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20mysterious%20male%20character%20reading%20a%20book%2C%20apocalyptic%20background%2C%20dramatic%20contrast%20lighting%2C%20dark%20blue%20and%20gold%20tones%2C%20professional%20webtoon%20cover&width=400&height=533&seq=hot-rec-04&orientation=portrait',
  },
  {
    id: '5',
    title: '世子消失了',
    author: '姜恩彩',
    genre: '古装 / 悬疑',
    rating: '9.4',
    views: '1,890万',
    latestChapter: '第98话',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20historical%20Korean%20prince%20character%20in%20hanbok%2C%20mysterious%20palace%20background%2C%20warm%20autumn%20tones%2C%20traditional%20Korean%20aesthetic%2C%20digital%20illustration&width=400&height=533&seq=hot-rec-05&orientation=portrait',
  },
  {
    id: '6',
    title: '恶女重生',
    author: '郑雅拉',
    genre: '恋爱 / 重生',
    rating: '9.3',
    views: '2,340万',
    latestChapter: '第145话',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20elegant%20female%20character%20in%20vintage%20dress%2C%20royal%20palace%20interior%2C%20rich%20burgundy%20and%20gold%20tones%2C%20villainess%20theme%2C%20professional%20webtoon%20cover&width=400&height=533&seq=hot-rec-06&orientation=portrait',
  },
];

export const latestUpdates = [
  {
    id: '7',
    title: '成为伯爵家的废物',
    author: '赵云熙',
    genre: '奇幻 / 转生',
    latestChapter: '第67话',
    updatedAt: '3分钟前',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20young%20nobleman%20character%20with%20mischievous%20expression%2C%20fantasy%20castle%20background%2C%20warm%20golden%20lighting%2C%20aristocratic%20aesthetic%2C%20digital%20webtoon%20illustration&width=400&height=533&seq=latest-01&orientation=portrait',
  },
  {
    id: '8',
    title: '反派的美学',
    author: '金多彬',
    genre: '恋爱 / 奇幻',
    latestChapter: '第89话',
    updatedAt: '15分钟前',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20charismatic%20villain%20female%20character%2C%20dark%20elegant%20attire%2C%20gothic%20mansion%20background%2C%20deep%20red%20and%20black%20tones%2C%20dramatic%20webtoon%20cover%20style&width=400&height=533&seq=latest-02&orientation=portrait',
  },
  {
    id: '9',
    title: 'SSS级猎人',
    author: '郑宇硕',
    genre: '动作 / 奇幻',
    latestChapter: '第134话',
    updatedAt: '28分钟前',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20powerful%20hunter%20male%20character%20with%20weapons%2C%20dungeon%20background%20with%20monsters%2C%20intense%20action%20pose%2C%20vibrant%20orange%20and%20dark%20tones%2C%20professional%20webtoon%20cover&width=400&height=533&seq=latest-03&orientation=portrait',
  },
  {
    id: '10',
    title: '末日生存指南',
    author: '朴敏俊',
    genre: '生存 / 恐怖',
    latestChapter: '第56话',
    updatedAt: '42分钟前',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20survivor%20character%20in%20post%20apocalyptic%20city%2C%20ruined%20buildings%20background%2C%20dark%20moody%20atmosphere%2C%20desaturated%20green%20and%20gray%20tones%2C%20thriller%20webtoon%20cover&width=400&height=533&seq=latest-04&orientation=portrait',
  },
  {
    id: '11',
    title: '龙王殿下请息怒',
    author: '李恩智',
    genre: '古装 / 恋爱',
    latestChapter: '第112话',
    updatedAt: '1小时前',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20dragon%20king%20character%20with%20regal%20presence%2C%20underwater%20palace%20background%2C%20mystical%20blue%20and%20gold%20tones%2C%20fantasy%20romance%20theme%2C%20elegant%20webtoon%20illustration&width=400&height=533&seq=latest-05&orientation=portrait',
  },
  {
    id: '12',
    title: '囚笼中的公主',
    author: '韩素希',
    genre: '古装 / 悬疑',
    latestChapter: '第78话',
    updatedAt: '1小时前',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20imprisoned%20princess%20character%20looking%20through%20window%2C%20dark%20tower%20room%20setting%2C%20melancholy%20mood%2C%20muted%20blue%20and%20silver%20tones%2C%20gothic%20romance%20webtoon%20style&width=400&height=533&seq=latest-06&orientation=portrait',
  },
  {
    id: '13',
    title: '星际流浪者',
    author: '崔成浩',
    genre: '科幻 / 冒险',
    latestChapter: '第45话',
    updatedAt: '2小时前',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20space%20adventurer%20character%20in%20futuristic%20suit%2C%20alien%20planet%20landscape%20background%2C%20cosmic%20neon%20colors%2C%20sci%20fi%20digital%20illustration%2C%20professional%20webtoon%20cover&width=400&height=533&seq=latest-07&orientation=portrait',
  },
  {
    id: '14',
    title: '天命之女',
    author: '张瑞妍',
    genre: '奇幻 / 恋爱',
    latestChapter: '第201话',
    updatedAt: '2小时前',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20destined%20heroine%20with%20magical%20powers%2C%20enchanted%20forest%20background%2C%20ethereal%20glowing%20light%2C%20soft%20purple%20and%20white%20tones%2C%20fantasy%20romance%20webtoon%20style&width=400&height=533&seq=latest-08&orientation=portrait',
  },
];

export const categories = [
  {
    slug: 'romance',
    name: '恋爱漫画',
    icon: 'ri-heart-line',
    count: 1256,
    description: '甜蜜浪漫的爱情故事',
    color: 'primary',
  },
  {
    slug: 'fantasy',
    name: '奇幻漫画',
    icon: 'ri-magic-line',
    count: 984,
    description: '充满想象力的奇幻世界',
    color: 'accent',
  },
  {
    slug: 'action',
    name: '动作漫画',
    icon: 'ri-sword-line',
    count: 867,
    description: '热血沸腾的战斗场面',
    color: 'secondary',
  },
  {
    slug: 'horror',
    name: '恐怖漫画',
    icon: 'ri-ghost-line',
    count: 432,
    description: '惊悚刺激的恐怖故事',
    color: 'primary',
  },
  {
    slug: 'ranking',
    name: '排行榜',
    icon: 'ri-trophy-line',
    count: 678,
    description: '人气评分热门榜单',
    color: 'accent',
  },
  {
    slug: 'latest',
    name: '最近更新',
    icon: 'ri-timer-flash-line',
    count: 543,
    description: '最新章节更新动态',
    color: 'secondary',
  },
  {
    slug: 'all',
    name: '全部漫画',
    icon: 'ri-grid-line',
    count: 389,
    description: '浏览全部漫画作品',
    color: 'primary',
  },
  {
    slug: 'featured',
    name: '专题推荐',
    icon: 'ri-star-line',
    count: 321,
    description: '编辑精选专题推荐',
    color: 'accent',
  },
];

export const testimonials = [
  {
    id: '1',
    name: '漫迷小王',
    avatar: 'https://readdy.ai/api/search-image?query=Asian%20young%20man%20portrait%20with%20warm%20smile%2C%20outdoor%20natural%20lighting%2C%20casual%20style%2C%20clean%20background%2C%20friendly%20expression%2C%20editorial%20portrait%20photography%20with%20soft%20bokeh&width=80&height=80&seq=avatar-01&orientation=squarish',
    role: '资深读者 · 3年漫龄',
    content: '虚空韩漫网真的太良心了！更新速度全网最快，画质高清，而且完全免费无删减。每天晚上刷更新已经成了我的日常习惯，推荐给所有喜欢韩漫的朋友！',
    rating: 5,
  },
  {
    id: '2',
    name: '樱花树下',
    avatar: 'https://readdy.ai/api/search-image?query=Asian%20young%20woman%20portrait%20with%20gentle%20smile%2C%20indoor%20soft%20lighting%2C%20elegant%20casual%20style%2C%20clean%20minimalist%20background%2C%20warm%20natural%20expression%2C%20editorial%20portrait&width=80&height=80&seq=avatar-02&orientation=squarish',
    role: '恋爱漫画爱好者',
    content: '这里的恋爱漫画分类超全，很多冷门佳作都能找到。下拉式阅读体验也很棒，手机上看完全不累。客服响应也很快，遇到问题秒回，太赞了！',
    rating: 5,
  },
  {
    id: '3',
    name: '剑心未冷',
    avatar: 'https://readdy.ai/api/search-image?query=Asian%20man%20portrait%20with%20cool%20expression%2C%20indoor%20studio%20lighting%2C%20modern%20casual%20black%20hoodie%2C%20clean%20dark%20background%2C%20editorial%20portrait%20photography&width=80&height=80&seq=avatar-03&orientation=squarish',
    role: '动作漫画死忠粉',
    content: '作为一个看了十年韩漫的老读者，虚空韩漫网的体验是最好的。页面简洁无广告，加载速度快，最重要的是所有作品都是无删减版本，原汁原味！',
    rating: 5,
  },
  {
    id: '4',
    name: '夜半书香',
    avatar: 'https://readdy.ai/api/search-image?query=Asian%20woman%20portrait%20with%20thoughtful%20expression%2C%20warm%20cafe%20lighting%2C%20cozy%20knit%20sweater%2C%20blurred%20bookshelf%20background%2C%20editorial%20portrait%20with%20soft%20ambient%20light&width=80&height=80&seq=avatar-04&orientation=squarish',
    role: '奇幻漫画爱好者',
    content: '更新准时、翻译质量高、排版清晰，这些都是虚空韩漫网的优势。而且收藏功能和历史记录很方便，再也不用担心忘记看到哪里了。强烈推荐！',
    rating: 5,
  },
];

export const siteStats = {
  totalManhua: '8,500+',
  totalChapters: '120,000+',
  dailyVisitors: '50万+',
  registeredUsers: '200万+',
};
